import store from '../store/index'
import API from '../services/api'
export const auth = {
  namespaced: true,
  state: {
    loggedIn: false,
    user: {},
    system_logo:"@/assets/img/vue-logo.png"
  },
  actions: {
    async getUser({ commit }) {
      return await API.get(`/api/admin`)
    },
    setLogo({ commit }, logo) {
      commit('setLogo', logo);
    },
    async logout({ commit }) {
      await API.post('/auth/logout',{refreshToken: localStorage.getItem('refresh_token')})
      .then(response =>{ 
          commit('logout');
       })
     
    },
    register({ commit }, user) {
      return AuthService.register(user).then(
        response => {
          commit('registerSuccess');
          return Promise.resolve(response.data);
        },
        error => {
          commit('registerFailure');
          return Promise.reject(error);
        }
      );
    }
  },
  mutations: {
    getUserSuccess(state, user) {
      console.log('userr',user)
      state.user = user
      state.loggedIn = true;     
    },
    loginFailure(state) {
      state.loggedIn = false;
      state.user = null;
    },
    setLogo(state, logo) {
      state.system_logo = logo;
    },
    logout(state) {
      state.loggedIn = false;
      store.state.meetings = {}
      state.user = {};
      localStorage.setItem('access_token',null)
      localStorage.setItem('refresh_token',null)
    },
  }
};
